import { Link } from 'react-router-dom'

// Public beta label is distinct from package tooling version.
// The pipeline supplies a unique marker for every deployed artifact.
export default function BetaReleaseNotice() {
  const marker = import.meta.env.VITE_BUILD_MARKER || 'development'
  const build = /^build-(\d+)-/.exec(marker)?.[1]
  return (
    <section
      aria-label="Beta release information"
      data-build-marker={marker}
      className="border-b border-civitas-gold bg-amber-50 px-4 py-3 text-civitas-navy"
    >
      <div className="mx-auto max-w-6xl text-sm">
        <p className="font-semibold">
          Beta Release — v0.1 · {build ? `Build ${build}` : marker === 'development' ? 'Development build' : marker}
        </p>
        <p className="mt-1">
          BECivitas is pre-release software and may contain bugs or inaccuracies. The terms,
          conditions, and limitations governing beta use are explained in the BECivitas
          Participation Agreement, presented for your review and acceptance before using
          interactive features.{' '}
          <Link to="/beta-agreement?view=1" className="font-semibold underline underline-offset-2 focus:outline focus:outline-2 focus:outline-offset-2">
            Read the Participation Agreement
          </Link>
        </p>
      </div>
      <p className="mx-auto mt-1 max-w-6xl text-sm">
        To report system or data issues—or share feedback of any kind—use our{' '}
        <Link to="/feedback" className="font-semibold underline underline-offset-2 focus:outline focus:outline-2 focus:outline-offset-2">
          feedback form
        </Link>{' '}to communicate your thoughts.
      </p>
    </section>
  )
}
